import moment from 'moment'

import isEmpty from 'lodash/isEmpty'

import { refreshToken } from './modules/auth'

export const hasValidToken = token => {
  const { issued_at, expires_in } = token // eslint-disable-line camelcase
  const now = moment()
  const refreshDate = moment(issued_at).add(+expires_in, 'second') // eslint-disable-line camelcase
  return refreshDate.isAfter(now)
}

export const getValidToken = async () => {
  const { getStore } = await import('../App')
  const store = getStore()
  const state = store && store.getState()
  const token = state && state.auth && state.auth.token

  if (isEmpty(token)) return null
  if (hasValidToken(token)) return token.access_token

  const refreshedToken = await getStore().dispatch(
    refreshToken(token.refresh_token),
  )

  return refreshedToken.payload.access_token
}
